import {
    SET_STATUSES_BY_PERIOD_LOADING,
    SET_CURRENT_STATUSES_BY_PERIOD_PAGE,
    SET_CURRENT_STATUSES_BY_PERIOD_SIZE,
    SET_STATUSES_BY_PERIOD_FILTER,
    SHOW_EXPORT_STATUSES_BY_PERIOD_LOADING,
    UPDATE_FILES_HISTORY,
    SET_FILES_HISTORY_LOADER,
    SET_CURRENT_FILES_PAGE,
    SET_CURRENT_FILES_SIZE
} from "../types/typesStatusesByPeriodList";

export function setStatusesByPeriodLoading(payload: boolean) {
    return {
        type: SET_STATUSES_BY_PERIOD_LOADING,
        payload: payload
    }
}

export function setStatusesByPeriodCurrentPage(payload: number) {
    return {
        type: SET_CURRENT_STATUSES_BY_PERIOD_PAGE,
        payload: payload
    }
}

export function setStatusesByPeriodCurrentPageSize(payload: number) {
    return {
        type: SET_CURRENT_STATUSES_BY_PERIOD_SIZE,
        payload: payload
    }
}

export function setStatusesByPeriodFilter(payload: any) {
    return {
        type: SET_STATUSES_BY_PERIOD_FILTER,
        payload: payload
    }
}

export function showStatusesByPeriodExportLoading(payload: boolean) {
    return {
        type: SHOW_EXPORT_STATUSES_BY_PERIOD_LOADING,
        payload: payload
    }
}

export function setFilesCurrentPage(payload: number) {
    return {
        type: SET_CURRENT_FILES_PAGE,
        payload: payload
    }
}

export function setFilesCurrentPageSize(payload: number) {
    return {
        type: SET_CURRENT_FILES_SIZE,
        payload: payload
    }
}
